import actionTypes from '../../actions/actionTypes';

const _initState = {
  isLoading: false,
  data: null
};

const sprava = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_SPRAVA_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_SPRAVA_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };
    
    case actionTypes.GET_SPRAVA_FAILURE:
      return _initState;
  
    case actionTypes.CHANGE_SPRAVA:
      return { ...state, isLoading: false, data: action.data };

    default:
      return state
  }
}

export default sprava;